module.exports = __webpack_public_path__ + "img/262.ffabcf9c.png";